import styled, { css } from 'styled-components/macro';

type WrapperProps = { $collapsed: boolean; $maxHeight: number };

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  overflow: hidden;

  ${({ $collapsed, $maxHeight }) =>
    $collapsed &&
    css`
      max-height: ${$maxHeight}px;
    `}
`;

type FadeProps = { $height: number; $resolvedColor: string };

export const Fade = styled.div<FadeProps>`
  ${({ $height, $resolvedColor }) => css`
    position: absolute;
    bottom: 0;
    right: 0;
    height: ${$height}px;
    display: flex;
    align-items: center;
    background-color: ${$resolvedColor};

    &::before {
      content: '';
      position: absolute;
      right: 100%;
      width: 80px;
      height: 100%;
      background: linear-gradient(to right, transparent, ${$resolvedColor});
      pointer-events: none;
    }
  `}
`;

export const ExpandButton = styled.button`
  ${({ theme }) => css`
    background: none;
    border: none;
    cursor: pointer;
    color: ${theme.colors.primary[700]};
    white-space: nowrap;
    transition-duration: ${theme.tokens.animation.duration.base};
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;

    &:hover {
      color: ${theme.colors.primary[800]};
    }
  `}
`;
